var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{class:_vm.baseClass},_vm._l((_vm.items),function(item,index){return _c('li',{key:item.id ?? index,class:`${_vm.baseClass}__item`},[_vm._t("default",null,{"item":item,"index":index})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }